<template>
    <div style="padding: 16px">
        <div class="top-Lv1">
            <span class="tittle-lv1">添加权限组</span>
        </div>
        <div class="mainContent">
            <div class="mainNav">
                <!--<Button type="primary" class="adds" size="small" @click="toAdd();handleSubmit">保存并继续添加</Button>-->
                <Button type="primary" size="small" @click="handleSubmit">保存</Button>
                <Button type="ghost" size="small" @click="$router.push({name:'permission'})">取消</Button>
            </div>
            <div class="froms">
                <Form ref="formValidate" :model="formValidate" label-position="left" :rules="ruleValidate" :label-width="90">
                    <Row>
                        <Col span="16">
                        <FormItem :label-width="120" label="权限组名称 :" prop="rolesName">
                            <Input size="small" v-model="formValidate.rolesName" placeholder="成员通过验证该手机后可加入企业"></Input>
                        </FormItem>
                        <FormItem :label-width="120" label="权限组英文名称 :" prop="rolesName">
                            <Input size="small" v-model="formValidate.alias" placeholder="成员通过验证该手机后可加入企业"></Input>
                        </FormItem>
                        </Col>
                    </Row>

                    <Tabs value="name1">
                        <TabPane label="应用端权限" name="name1">
                            <Scroll style="margin-top: -25px" height="450">
                                <div v-for="(item,key) in itemList" :key="key">
                                    <div class="mainNav" style="background-color: #f8f8f9;border: 0;line-height: 24px;font-weight: bold">{{item.title}} <div class="iv-icon-down" @click="showPermiss(item.id)"><Icon v-if="item.access" type="chevron-down"></Icon><Icon v-if="!item.access" type="chevron-right"></Icon></div>
                                    </div>
                                    <div v-for="(items,key1) in item.children" :key="key1" :class="item.access ? 'showCheck' :  'hideCheck'">
                                        <div style="padding-top:6px;margin-top:6px;margin-left: 20px;">
                                            <Checkbox
                                                :indeterminate="auths[items.id].indeterminate"
                                                :value="auths[items.id].checkAll"
                                                @click.prevent.native="handleCheckAll(items.id)" :key="items.id">{{items.title}}</Checkbox>
                                        </div>
                                        <CheckboxGroup v-model="formItem.checkbox" @on-change="checkAllGroupChange" v-if="items !== item.children[item.children.length -1]" style="border-bottom: 1px dashed #e9e9e9;">
                                            <Checkbox style="font-weight: 100;margin-left: 20px;"  v-for="(res,key2) in items.children" :key="key2" :label="res.title"></Checkbox>
                                        </CheckboxGroup>
                                        <CheckboxGroup v-model="formItem.checkbox" @on-change="checkAllGroupChange" v-if="items === item.children[item.children.length -1]">
                                            <Checkbox style="font-weight: 100;margin-left: 20px;"  v-for="(res,key3) in items.children" :key="key3" :label="res.title"></Checkbox>
                                        </CheckboxGroup>
                                    </div>
                                </div>
                            </Scroll>
                        </TabPane>
                        <TabPane label="APP端权限" name="name2">
                            <Scroll style="margin-top: -25px" height="450">
                                <!--<p class="topName">{{$store.getters.comInfo.contact}} <span>超级管理员</span></p>-->
                                <Form :model="formItem">
                                    <FormItem>
                                        <div style="font-size: 24px;font-weight: bold;text-align: center;height: 405px;line-height: 200px">我是CRM权限，暂时不设置任何权限</div>
                                    </FormItem>
                                </Form>
                                <!--<Checkbox style="margin-top: 5px" v-model="single">全部选择</Checkbox>-->
                                <!--<Button v-if="button==='个人权限' && permissionUpdate" style="float: right" @click="confirmUpdate(2)" type="primary">确认修改</Button>-->
                                <!--<Button v-if="button==='权限组' && permissionRoles" style="float: right" @click="confirmRoles(2)" type="primary">确认修改</Button>-->
                            </Scroll>
                        </TabPane>
                        <TabPane label="WEB端权限" name="name3">
                            <Form :model="formItem">
                                <Scroll height="450" style="margin-top: -25px;border-bottom: 1px solid #dddee1">
                                    <FormItem>
                                        <div v-for="(items,key) in webList" :key="key">
                                            <div style="padding-top:6px;margin-top:6px;">
                                                <Checkbox
                                                    :indeterminate="webAuths[items.id].indeterminate"
                                                    :value="webAuths[items.id].checkAll"
                                                    @click.prevent.native="webhandleCheckAll(items.id)" :key="items.id">{{items.title}}</Checkbox>
                                            </div>
                                            <CheckboxGroup v-model="formItem.checkbox" style="border-bottom: 1px solid #e9e9e9;" @on-change="webcheckAllGroupChange">
                                                <Checkbox style="font-weight: 100;"  v-for="(res,key1) in items.children" :key="key1" :label="res.title"></Checkbox>
                                            </CheckboxGroup>
                                        </div>
                                    </FormItem>
                                </Scroll>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Form>
            </div>
            <div class="mainNav">
                <Button type="primary" size="small" @click="handleSubmit">保存</Button>
                <Button type="ghost" size="small" @click="$router.push({name:'permission'})">取消</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import ruleValidate from '../../validator'
    import {HOST} from '../../../config';

    export default {
        name: 'memberAdd',
        data() {
            return {
                itemList:[],
                webList:[],
                modal1: false,
                data: [],
                auth: [],
                auths: [],
                webAuth:[],
                webAuths:[],
                formValidate: {
                    rolesName:'',
                    alias:''
                },
                formItem: {
                    checkbox:[],
                },
                theme1: 'light',
                memberList: [],
                curMember:'',
                indeterminate: true,
                checkAll: false,
                arr: [],
            }
        },
        computed:{
            ruleValidate:function () {
                return ruleValidate
            }
        },
        mounted() {
            this.getAuth();
        },
        methods: {
            //权限列表
            getAuth() {
                this.$http.get(this.$api.GET_AUTH).then(res => {
                    this.itemList = res.data.data;
                    this.webList = res.data.web;
                    this.pcList();
                    this.webLists();
                }, err => {
                    this.$Message.error('网络错误');
                });
            },

            //全部选择
            handleCheckAll (val) {
                if(this.auths[val].indeterminate){
                    this.auths[val].checkAll = true;
                }else{
                    this.auths[val].checkAll = !this.auths[val].checkAll;
                }
                this.auths[val].indeterminate = false;
                if (this.auths[val].checkAll) {
                    if(this.formItem.checkbox.length === 0){
                        this.formItem.checkbox = this.auths[val].name;
                    }else{
                        this.formItem.checkbox.forEach(item=>{
                            this.auths[val].name.map(items=>{
                                if(item === items){
                                    let index = this.formItem.checkbox.indexOf(item);
                                    this.formItem.checkbox.splice(index,1);
                                }
                            })
                        })
                        this.formItem.checkbox = this.formItem.checkbox.concat( this.auths[val].name);
                    }
                }else {
                    if (this.formItem.checkbox === this.auths[val].name) {
                        this.formItem.checkbox = [];
                    } else {
                        for(var i=0; i<=this.formItem.checkbox.length; i++){
                            this.auths[val].name.forEach(items => {
                                if (this.formItem.checkbox[i] === items) {
                                    this.formItem.checkbox.splice(i,1);
                                }
                                this.itemList.map(item=>{
                                    if(item.children.length > 0){
                                        item.children.map(val=>{
                                            if(val.children.length > 0){
                                                val.children.map(value=>{
                                                    if(value.title === items){
                                                        if(this.formItem.checkbox.indexOf(val.title) > 0){
                                                            this.formItem.checkbox.splice(this.formItem.checkbox.indexOf(val.title),1);
                                                        }
                                                    }
                                                })
                                            }

                                        })
                                    }
                                })
                            })
                        }
                    }
                }
            },

            //单独选择
            checkAllGroupChange (data) {
                let permission = [];
                this.itemList.map(item=>{
                    item.children.map(items=>{
                        if(items.children.length>0){
                            let arr = [];
                            items.children.map(res=>{
                                if(data.indexOf(res.title)>= 0){
                                    permission.push(res.name);
                                    arr.push(true);
                                }else{
                                    arr.push(false);
                                }
                            })

                            if(arr.indexOf(false)>= 0 && arr.indexOf(true)>= 0){
                                //不全选
                                this.auths[items.id].indeterminate = true;
                                this.auths[items.id].checkAll = false;
                            }else if(arr.indexOf(false) < 0){
                                //全选
                                this.auths[items.id].indeterminate = false;
                                this.auths[items.id].checkAll = true;
                            }
                            if(this.auths[items.id].indeterminate || this.auths[items.id].checkAll){
                                permission.push(items.name);
                                permission.push(item.name);
                            }
                        }
                    })

                })
//                this.arr = permission;
                this.arr = this.arr.concat(permission);
            },

            //web全部选择
            webhandleCheckAll (val) {
                if(this.webAuths[val].indeterminate){
                    this.webAuths[val].checkAll = false;
                }else{
                    this.webAuths[val].checkAll = !this.webAuths[val].checkAll;
                }
                this.webAuths[val].indeterminate = false;
                if (this.webAuths[val].checkAll) {
                    if(this.formItem.checkbox.length === 0){
                        this.formItem.checkbox = this.webAuths[val].name;
                    }else{
                        this.formItem.checkbox.forEach(item=>{
                            this.webAuths[val].name.map(items=>{
                                if(item === items){
                                    let index = this.formItem.checkbox.indexOf(item);
                                    this.formItem.checkbox.splice(index,1);
                                }
                            })
                        })
                        this.formItem.checkbox = this.formItem.checkbox.concat( this.webAuths[val].name);
                    }
                }else {
                    if (this.formItem.checkbox === this.webAuths[val].name) {
                        this.formItem.checkbox = [];
                    } else {
                        for(var i=0; i<=this.formItem.checkbox.length; i++){
                            this.webAuths[val].name.forEach(items => {
                                if (this.formItem.checkbox[i] === items) {
                                    this.formItem.checkbox.splice(i,1);
                                }
                            })
                        }
                    }
                }
            },

            //web单独选择
            webcheckAllGroupChange (data) {
                let permission = [];
                this.webList.map(item=>{
                    let arr = [];
                    item.children.map(items=>{
                        if(data.indexOf(items.title)>= 0){
                            permission.push(items.name);
                            arr.push(true);
                        }else{
                            arr.push(false);
                        }
                    })
                    if(arr.indexOf(false)>= 0 && arr.indexOf(true)>= 0){
                        this.webAuths[item.id].indeterminate = true;
                        this.webAuths[item.id].checkAll = false;
                        permission.push(item.name);
                    }else if(arr.indexOf(false) < 0){
                        this.webAuths[item.id].indeterminate = false;
                        this.webAuths[item.id].checkAll = true;
                        permission.push(item.name);
                    }else{
                        this.webAuths[item.id].indeterminate = false;
                        this.webAuths[item.id].checkAll = false;
                    }
                })
                this.arr = this.arr.concat(permission);
            },

            //处理pc权限数据
            pcList() {
                let auth = [];
                let auths = [];
                if(this.itemList.length > 0)
                    this.itemList.forEach(item=>{
                        auth.push(item.title);
                        if(item.children.length > 0){
                            item.children.forEach(items=>{
                                let arr = [];
                                let result = [];
                                if(items.children.length > 0){
                                    items.children.forEach(res=>{
                                        arr.push(res.title);
                                    })
                                }
                                result.name = arr;
                                result.indeterminate = false;
                                result.checkAll = false;
                                auths[items.id] = result;
                            })
                        }
                    });
                this.auth = auth;
                this.auths = auths;
            },

            //处理web权限数据
            webLists(){
                let auth = [];
                let auths = [];
                if(this.webList.length > 0)
                    this.webList.forEach(item=>{
                        auth.push(item.title);
                        let arr = [];
                        let result = {};
                        if(item.children.length > 0){
                            item.children.forEach(items=>{
                                arr.push(items.title);
                            })
                        }

                        result.name = arr;
                        result.indeterminate = false;
                        result.checkAll = false;
                        auths[item.id] = result;
                    });
                this.webAuth = auth;
                this.webAuths = auths;
            },

            //添加权限组
            handleSubmit() {
                this.checkAllGroupChange(this.formItem.checkbox);
                this.webcheckAllGroupChange(this.formItem.checkbox);
                let data = [...new Set(this.arr)];
                this.$http.post(this.$api.ROLES, {
                    gurad_name: 'web',
                    alias: this.formValidate.alias,
                    name: this.formValidate.rolesName,
                    data: data,
                    uid:this.$store.getters.userInfo.id,
                    com_id: this.$store.getters.userInfo.com_id,
                }).then(res => {
                    if(res.data.status == 1){
                        this.$Message.info('新增权限成功');
                        this.$router.push({name:'permission'});
                    }else{
                        this.$Message.error(res.data.msg);
                    }
                }, err => {
                    this.$Message.error('网络错误');
                });
            },

            //是否显示按钮权限
            showPermiss(val){
                this.checkId = val;
                this.itemList.forEach(item=>{
                    if(item.id === val){
                        item.access = !item.access;
                    }
                })
            },
        },

    }
</script>

<style scoped>
    .mainNav button {
        background-color: #fff;
    }

    .mainNav button:first-child {
        background-color: #2d8cf0;
        margin-left: 100px;
    }

    .mainNav .adds:hover {
        opacity: 0.8;
    }

    .mainNav {
        height: 34px;
        border-bottom: 1px solid #ccc;
    }

    .iv-icon-down {
        float: right;
        margin-top: 1px;
        margin-right: -15px;
        cursor: pointer;
        display: inline;
        width: 40px;
        height: 28px;
    }

    .froms {
        margin-left: 100px;
        padding: 8px 13px;
    }

    .photos {
        position: absolute;
        top: 6px;
        left: 0;
        width: 60px;
        height: 60px;
        line-height: 60px;
        border-radius: 30px;
        font-size: 40px;
    }

    .rows {
        padding: 20px 0;
        border-bottom: 1px solid #E4E6E9;
    }

    .ivu-form-item {
        margin-bottom: 2px;
    }

    .modelBox {
        padding: 4px 14px;
    }

    .memberList {
        height: 367px;
        margin-top: 20px;
    }

    .memberList li {
        height: 28px;
        padding-left: 28px;
        line-height: 28px;
    }

    .memberList li i {
        font-size: 16px;
        line-height: 27px;
        vertical-align: top;
    }

    .memberList li i:first-child {
        margin-right: 3px;
        color: #2d8cf0;
    }

    .memberList li i:last-of-type {
        margin-left: 10px;
        color: #ccc;
        font-size: 12px;
    }

    .xuanZe {
        margin-left: 20px;
        padding-left: 20px;
        border-left: 1px solid #E4E6E9;
        height: 407px;
    }

    .xuanZe span {
        display: block;
        font-size: 14px;
        color: #787878;
        margin-bottom: 10px;
    }

    .menberType {
        border: 1px solid #E4E6E9;
        display: inline-block;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
    }

    .menberType i:first-child {
        margin-right: 3px;
        color: #2d8cf0;
    }

    .menberType i:last-child {
        margin-left: 20px;
        color: #ccc;
    }
    .hideCheck {
        display: none;
    }
    .showCheck {
        display: block;
    }
</style>




// WEBPACK FOOTER //
// src/components/permission/routeAdd.vue